
export const ShieldIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Shield"
  >
    <g clipPath="url(#clip0_2759_3783)">
      <path
        d="M9.22917 12.5H10.7708C10.8819 12.5 10.9722 12.4583 11.0417 12.375C11.125 12.2778 11.1528 12.1736 11.125 12.0625L10.75 9.8125C10.9861 9.6875 11.1667 9.50694 11.2917 9.27083C11.4306 9.03472 11.5 8.77778 11.5 8.5C11.5 8.08333 11.3542 7.72917 11.0625 7.4375C10.7708 7.14583 10.4167 7 10 7C9.58333 7 9.22917 7.14583 8.9375 7.4375C8.64583 7.72917 8.5 8.08333 8.5 8.5C8.5 8.77778 8.5625 9.03472 8.6875 9.27083C8.82639 9.50694 9.01389 9.6875 9.25 9.8125L8.875 12.0625C8.84722 12.1736 8.86806 12.2778 8.9375 12.375C9.02083 12.4583 9.11806 12.5 9.22917 12.5ZM10 17.9167C9.91667 17.9167 9.83333 17.9167 9.75 17.9167C9.66667 17.9028 9.59028 17.8819 9.52083 17.8542C7.70139 17.2569 6.24306 16.1528 5.14583 14.5417C4.04861 12.9306 3.5 11.1736 3.5 9.27083V5.52083C3.5 5.20139 3.58333 4.91667 3.75 4.66667C3.93056 4.41667 4.16667 4.23611 4.45833 4.125L9.45833 2.20833C9.63889 2.13889 9.81944 2.10417 10 2.10417C10.1806 2.10417 10.3611 2.13889 10.5417 2.20833L15.5417 4.125C15.8333 4.23611 16.0625 4.41667 16.2292 4.66667C16.4097 4.91667 16.5 5.20139 16.5 5.52083V9.27083C16.5 11.1736 15.9514 12.9306 14.8542 14.5417C13.7569 16.1528 12.2986 17.2569 10.4792 17.8542C10.4097 17.8819 10.3333 17.9028 10.25 17.9167C10.1667 17.9167 10.0833 17.9167 10 17.9167ZM10 16.4375C11.4444 15.9931 12.6389 15.0972 13.5833 13.75C14.5278 12.4028 15 10.9097 15 9.27083V5.52083L10 3.60417L5 5.52083V9.27083C5 10.9097 5.47222 12.4028 6.41667 13.75C7.36111 15.0972 8.55556 15.9931 10 16.4375Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2759_3783">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
